import React from 'react';
import clsx from 'clsx';
import RimacLogo from '../RimacLogo';
import Typography from '../Typography';

const Footer = () => {
    return (
        <footer className={clsx(['container-fluid', 'footer'])}>
            <div className={clsx(['container', 'footer__wrapper'])}>
                <RimacLogo fill="#D4D5E8"/>
                <Typography
                    className="footer__text"
                    size="small"
                    font="secondary"
                    weight="thin"
                    color="gray2"
                >
                    © 2020 RIMAC Seguros y Reaseguros.
                </Typography>
            </div>
        </footer>
    );
};

export default Footer;
